import { useEffect, useState } from 'react';

import toast from 'react-hot-toast';

import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { BarChart, Bar } from 'recharts';



function AlcanceMensal({ dadosGraf }) {

    console.log('### Iniciando AlcanceMensal ###');

    const COLORS = ['#4567a9', '#d64550'];

    
    return (
        <div className='h-100 div-com-borda p-3 d-flex flex-column flex-md-row'>
            <div className='aligm-center w-100 text-center'>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={dadosGraf}
                        margin={{
                            left: 0,
                            right: 30
                        }}
                    >
                        <XAxis dataKey="mesReferenciaFormatado" fontSize={9} axisLine={false}/>
                        <YAxis fontSize={9} axisLine={false} />
                        <Tooltip />
                        <Bar
                            dataKey="Alcance Mensal"
                            stackId="as"
                            fill="#4567a9"
                            label={{ fill: "white", fontSize: 14, position: 'middle', fontWeight: 'bold'}}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default AlcanceMensal
